import { ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { BKJSideModal } from 'components/BKJSideModal';
import { FormWrapper } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.styled';
import {
  removePositionModalRoutingService,
  useRemovePositionModalUIContext,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.ui.context';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
import {
  RemovePositionDetailComponentMap,
  RemovePositionViewsWithTabs,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.constants';

const EditableViews = ['EditJaneView'];

export const RemovePositionModalComponent: FC = () => {
  const {
    isOpen,
    removePositionActiveModalView,
    isConfirmDeleteOpen,
    setIsConfirmDeleteOpen,
    shift_id,
  } = useRemovePositionModalUIContext();

  const Component = RemovePositionDetailComponentMap[removePositionActiveModalView];

  const { t } = useTranslation();

  const modalHeader = {
    RemovePositionView: t('location_settings:REMOVE_POSITION'),
    PositionTeamMembersView: t('location_settings:REMOVE_POSITION'),
    JaneDetailsView: t('team-member:Team Member Profile'),
    EditJaneView: t('location_settings:EDIT_POSITION'),
    OpenShiftsView: t('location_settings:REMOVE_POSITION'),
    DetailView: `${t('dashboard:SHIFT')} # ${shift_id}`,
  };
  const handleClose = useCallback(() => {
    if (EditableViews.includes(removePositionActiveModalView)) {
      setIsConfirmDeleteOpen(true);
      return;
    }
    if (removePositionActiveModalView === 'JaneDetailsView') {
      removePositionModalRoutingService.goToView('PositionTeamMembersView');
      return;
    }
    removePositionModalRoutingService.close();
  }, [setIsConfirmDeleteOpen, removePositionActiveModalView]);

  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={handleClose}
      showBackButton={removePositionModalRoutingService.isBackButtonVisible()}
      onBack={() => {
        if (removePositionActiveModalView === 'DetailView') {
          removePositionModalRoutingService.goToView('OpenShiftsView');
        } else if (removePositionActiveModalView === 'EditJaneView') {
          removePositionModalRoutingService.goToView('JaneDetailsView');
        } else removePositionModalRoutingService.goToPrevView();
      }}
      headerComponent={modalHeader[removePositionActiveModalView]}
      hasTabs={RemovePositionViewsWithTabs.includes(removePositionActiveModalView)}
    >
      <ErrorBoundary
        componentName="RemovePositionViewModal"
        showLogo={!WhiteLabelAccessor.isWhiteLabelled()}
      >
        <FormWrapper>
          <BKJCenteredDialog
            isOpen={isConfirmDeleteOpen && isOpen}
            variant="Danger"
            title={t('location_settings:DISCARD_CHANGES')}
            text={''}
            cancelLabel={t('auth:CANCEL')}
            actionLabel={t('create_shifts:DISCARD')}
            onAction={() => {
              setIsConfirmDeleteOpen(false);
              removePositionModalRoutingService.goToPrevView();
            }}
            onCancel={() => setIsConfirmDeleteOpen(false)}
            onClose={() => setIsConfirmDeleteOpen(false)}
          />
          {isOpen && <Component />}
        </FormWrapper>
      </ErrorBoundary>
    </BKJSideModal>
  );
};
